export default __webpack_public_path__ + "static/media/video7.fbc1546f.webp";